import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FooterModule } from '@nibtravel/shared/ui/components/footer';
import { HeaderModule } from '@nibtravel/shared/ui/components/header';
import { HeroModule } from '@nibtravel/shared/ui/components/hero';
import { SidebarModule } from '@nibtravel/shared/ui/components/sidebar';

import { BaseLayoutComponent } from './base-layout/base-layout.component';
import { ContentLayoutComponent } from './content-layout/content-layout.component';
import { LayoutComponent } from './layout.component';

@NgModule({
  imports: [
    CommonModule,
    HeaderModule,
    HeroModule,
    FooterModule,
    SidebarModule,
  ],
  declarations: [LayoutComponent, BaseLayoutComponent, ContentLayoutComponent],
  exports: [LayoutComponent, BaseLayoutComponent, ContentLayoutComponent],
})
export class LayoutModule {}
